import React from "react";
import { useDocTransmittalContext } from "../DocTransmittal.context";
import { Box, Button, Grid, Typography } from "@mui/material";
import { labelledBoxStyles } from "../../../../../../../styles/muiProps";

import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import { FileUpload } from "./FilesForm";
import DataForm from "./DataForm";
import InputGroupShape from "../../../../../../../components/Inputs/InputGroupShape";
import SelectedFileCard from "./SelectedFileCard";
import {
  clientDataGrid,
  documentTransmittalDataGrid,
  projectDataGrid,
  vendorDataGrid,
} from "./dataGrids";
import ReceiverRadioBtns from "./ReceiverRadioBtns";
import ReceiverForm from "./ReceiverForm";
import DocsTable from "./DocsTable";

export default function DocTransmittalForm() {
  const { newDoc, files, setFiles, onSubmit } = useDocTransmittalContext();

  return (
    <Box sx={{ p: 2, pt: 0, width: "100%" }}>
      <Box sx={{ ...labelledBoxStyles, width: "100%" }}>
        <Typography variant="h5" gutterBottom>
          <CreateNewFolderIcon
            sx={{
              fontSize: 28,
              transform: "translateY(5px)",
              mr: 0.5,
              color: "#444",
            }}
          />{" "}
          Create New Document Transmittal
        </Typography>
        <br />
        <Grid container spacing={1} sx={{ p: 2 }}>
          <Grid item xs={7}>
            <InputGroupShape name="Document Transmittal Details">
              <DataForm
                dataGrid={documentTransmittalDataGrid}
                values={newDoc}
              />
            </InputGroupShape>

            {/* {files.length > 0 && (
              <Grid item xs={12}>
                <InputGroupShape
                  name="Selected Documents"
                  sx={{ display: "flex" }}
                >
                  {files.map((file, idx) => (
                    <SelectedFileCard key={idx} file={file} />
                  ))}
                </InputGroupShape>
              </Grid>
            )} */}

            {/* <InputGroupShape name="Selected Documents" > */}
            <DocsTable sx={{ mt: 2.5 }} />
            {/* </InputGroupShape> */}
          </Grid>

          {/* ------------------------- Right Side: Metadata ---------------------------------- */}
          <Grid item xs={5}>
            <InputGroupShape name="WBS Details">
              <DataForm
                dataGrid={projectDataGrid}
                values={newDoc?.project}
                formName="project"
              />
            </InputGroupShape>

            <InputGroupShape
              name="Receiver Details"
              sx={{
                mt: 4,
                display: "flex",
                alignItems: "center",
              }}
            >
              <ReceiverRadioBtns />
              <ReceiverForm />

              {/* <DataForm
                dataGrid={
                  newDoc.receiverType === "Client"
                    ? clientDataGrid
                    : vendorDataGrid
                }
                values={newDoc?.receiver}
                formName="receiver"
              /> */}
            </InputGroupShape>
          </Grid>
        </Grid>

        {/* <Box sx={{ my: 1 }}>
          <FileUpload files={files} setFiles={setFiles} />
        </Box> */}

        <Box sx={{ textAlign: "right", px: 3, py: 1 }}>
          <Button variant="contained" onClick={onSubmit}>
            Send to {newDoc.receiverType}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
